/** A question about an answer the player gave to a year's card ("What is the swap I chose doing for my capital?"), answered from their own released report: the answer named, and the card answers' effect on the score. */
import type { RoundReport } from "@bsim/contracts";
import { cardEffect } from "../results/cardEffect";

const ASKS_ABOUT_OWN = /\b(?:i|we|my|our)\b/i;
const STOP = new Set(["what", "does", "doing", "your", "with", "that", "this", "have", "chose", "choose", "chosen", "from", "about", "were", "when", "which", "capital", "answer", "answered", "card"]);
const wordsOf = (text: string): string[] => text.toLowerCase().split(/[^a-z0-9]+/).filter((w) => w.length >= 4 && !STOP.has(w));

/** The released cards' answers the question is about, said with the figure the results page gives for them; null when the question names none of them. */
export function cardAnswerReply(question: string, reports: readonly (RoundReport | undefined)[], yearName: (roundNo: number) => string = (n) => `year ${n}`): string | null {
  if (!ASKS_ABOUT_OWN.test(question)) return null;
  const asked = new Set(wordsOf(question));
  for (const report of reports) {
    if (report === undefined) continue;
    for (const e of report.events) {
      const choice = e.response === null || e.response === undefined ? undefined : e.card.choices.find((c) => c.id === e.response?.choiceId);
      if (choice === undefined) continue;
      if (![...wordsOf(choice.label), ...wordsOf(e.card.title)].some((w) => asked.has(w))) continue;
      const line = cardEffect(report).line;
      return `In ${yearName(report.roundNo)} you answered “${e.card.title}” with option ${choice.id}: ${choice.label}.${line === null || line === undefined || line === "" ? "" : ` ${line}`}`;
    }
  }
  return null;
}
